var switchImage = function(t, e, r) {
	jQuery(r).parents("a").attr("href", t.replace("_grande", "_1024x1024")), jQuery(r).attr("src", t)
};
jQuery(function(t) {
	function e() {
		console.log("Init Thumbnails"), t(".product-slider--thumbs__image a").on("click", function(e) {
			e.preventDefault(), switchImage(t(this).attr("href"), null, t(".product-image--main img")[0])
		}), t(".slider-control--left").on("click", function(t) {
			t.preventDefault(), n.trigger("prev.owl.carousel")
		}), t(".slider-control--right").on("click", function(t) {
			t.preventDefault(), n.trigger("next.owl.carousel")
		})
	}

	function r() {
		t(".form-button--subtract").on("click", function(e) {
			var r = t(this).siblings(".input-quantity"),
				a = r.val();
			if (a > 1) var o = parseFloat(a) - 1;
			else o = 1;
			r.val(o)
		}), t(".form-button--add").on("click", function(e) {
			var r = t(this).siblings(".input-quantity"),
				a = r.val(),
				o = parseFloat(a) + 1;
			r.val(o)
		})
	}

	function a() {
		t(".user-control__nav-toggle").on("click", function(e) {
			e.preventDefault(), t(".primary-nav").toggleClass("nav-open")
		}), t(".nav-closer").on("click", function(e) {
			e.preventDefault(), t(".primary-nav").toggleClass("nav-open")
		})
	}
	var o = document.createElement("input");
	"placeholder" in o || (t("[placeholder]").each(function() {
		if ("" === t(this).val()) {
			var e = t(this).attr("placeholder");
			t(this).val(e).addClass("hint")
		}
	}), t("[placeholder]").focus(function() {
		t(this).val() === t(this).attr("placeholder") && t(this).val("").removeClass("hint")
	}).blur(function() {
		"" === t(this).val() && t(this).val(t(this).attr("placeholder")).addClass("hint")
	})), t("input.error, textarea.error").focus(function() {
		t(this).removeClass("error")
	}), t("form :submit").click(function() {
		return t(this).parents("form").find("input.hint, textarea.hint").each(function() {
			t(this).val("").removeClass("hint")
		}), !0
	});
	var i = function() {
		return document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image", "1.1")
	};
	i() || t('img[src*=".svg"]').remove();
	t(".article img").load(function() {
		var e = t(this).attr("src").replace(/_grande\.|_large\.|_medium\.|_small\./, "."),
			r = t(this).width();
		t(this).attr("src", e).attr("width", r).removeAttr("height")
	});
	t(".product__thumbs__image a").on("click", function(e) {
		e.preventDefault(), switchImage(t(this).attr("href"), null, t(".product-image--main img")[0])
	});
	var n = t(".product-slider--thumbs");
	t(".product-slider--thumbs").size() && n.owlCarousel({
		items: 5,
		loop: !0,
		margin: 15,
		onInitialized: e,
		dots: !1
	});
	var l = t(".home-hero");
	if (t(".home-hero").size() && l.owlCarousel({
			items: 1,
			autoplay: !0,
			autoplaySpeed: 400,
			autoplayTimeout: 5e3,
			autoplayHoverPause: !0,
			loop: !0,
			dots: !0
		}), a(), t(".product-downloads").size()) {
		var s = t("div.product-downloads");
		t(".product-downloads__tab").on("click", function(e) {
			e.preventDefault(), s.toggleClass("buy"), t(".product-downloads__tab").toggleClass("tab-open")
		})
	}
	t(".product-quantity").size() && r(), t(".sort-by").size() && t(".sort-by").customSelect(), t(".currency-picker").size() && t(".currency-picker").customSelect({
		customClass: "currency-picker"
	})
	if($('.licensing__spotify__player').size()){
		console.log('FOUND');
		var newHeight = $(".licensing__spotify").height();
        $(".spotify_frame").height(newHeight);
	}
});